import React from "react";
import "../styles/Mapa.css";
import {
  FaClock,
  FaDirections,
  FaEnvelope,
  FaFacebook,
  FaGlobe,
  FaMapMarkerAlt,
  FaShareAlt,
  FaWhatsapp,
} from "react-icons/fa";
import { trackEvent, trackWhatsAppClick } from "../utils/analytics";

const websiteURL = "https://nican-landing-page.vercel.app/";
const mapsURL =
  "https://www.google.com.mx/maps/search/+linderos+de+ixtapaluca+pozo+9,+Ixtapaluca,+Mexico,+56530";
const whatsappURL =
  "https://wa.me/525579118589?text=Podria%20solicitar%20un%20poco%20mas%20de%20informacion%20de%20sus%20cursos%3F";

function Mapa() {
  const handleShare = () => {
    trackEvent("location_share_click", {
      event_category: "contacto",
      click_source: "mapa",
    });
    const message = `Centro Capacitador y Evaluador Nican
Horario de oficina: 9:00 am - 3:00 pm de Lunes a Sabado.

Contactanos:
WhatsApp: 5579118589
Correo: fundacionnican2020@hotmail.com
Facebook: https://www.facebook.com/centro.Nican
Google Maps: ${mapsURL}`;

    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");
  };

  return (
    <section className="mapa-section" id="mapa">
      <div className="container">
        <div className="mapa-heading" data-aos="fade-up">
          <span>Ubicacion y contacto</span>
          <h2>Nos encontramos cerca de ti</h2>
          <p>
            Visitanos en Ixtapaluca o habla con un asesor para resolver dudas
            sobre cursos, horarios, certificaciones y proximas fechas.
          </p>
        </div>

        <div className="mapa-shell" data-aos="fade-up" data-aos-delay="120">
          <div className="mapa-info-panel">
            <div className="mapa-location-card">
              <div className="mapa-pin">
                <FaMapMarkerAlt />
              </div>
              <div>
                <p className="mapa-label">Centro Capacitador y Evaluador</p>
                <h3>Nican</h3>
                <p>
                  Linderos de Ixtapaluca Pozo 9, Ixtapaluca, Estado de Mexico,
                  C.P. 56530
                </p>
              </div>
            </div>

            <div className="mapa-details-grid">
              <article>
                <FaClock />
                <div>
                  <strong>Horario de oficina</strong>
                  <p>9:00 am - 3:00 pm, Lunes a Sabado</p>
                </div>
              </article>
              <article>
                <FaWhatsapp />
                <div>
                  <strong>WhatsApp</strong>
                  <a
                    href={whatsappURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackWhatsAppClick("mapa_contacto")}
                  >
                    5579118589
                  </a>
                </div>
              </article>
              <article>
                <FaEnvelope />
                <div>
                  <strong>Correo</strong>
                  <a
                    href="mailto:fundacionnican2020@hotmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    fundacionnican2020@hotmail.com
                  </a>
                </div>
              </article>
              <article>
                <FaFacebook />
                <div>
                  <strong>Facebook</strong>
                  <a
                    href="https://www.facebook.com/centro.Nican?mibextid=ZbWKwL"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Centro Nican
                  </a>
                </div>
              </article>
            </div>

            <div className="mapa-actions">
              <a
                className="mapa-primary-action"
                href={mapsURL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackEvent("directions_click", {
                    event_category: "ubicacion",
                    click_source: "mapa",
                  })
                }
              >
                <FaDirections />
                Como llegar
              </a>
              <button className="mapa-secondary-action" onClick={handleShare}>
                <FaShareAlt />
                Compartir ubicacion
              </button>
              <a
                className="mapa-link-action"
                href={websiteURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGlobe />
                Sitio web
              </a>
            </div>
          </div>

          <div className="mapa-frame-panel" aria-label="Mapa de Fundacion Nican">
            <iframe
              title="Fundacion Nican ubicacion en Ixtapaluca"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.2180142510426!2d-98.8636925!3d19.3384195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cd888c50a1532d%3A0x4ff7b6fcaeeb2c4!2sLinderos%20de%20Ixtapaluca%20Pozo%209%2C%20Ixtapaluca%2C%20Mexico%2C%2056530!5e0!3m2!1ses!2smx!4v1638299084296!5m2!1ses!2smx"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mapa;
